import { createUseStyles } from '../../theme/theming';

const useTimerCallPageStyles = createUseStyles((theme) => ({
  timerAndCallSection: {
    padding: ({ isMobile } = {}) => (isMobile ? '24px' : '80px 120px'),
    background: theme?.colors?.white,
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
  },
  timerAndCallContainer: {
    padding: '72px',
    background: '#F4F9FF',
    borderRadius: '8px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.16)'
  },

  timerAndCallBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '42px',
    justifyContent: 'center',
    alignItems: 'center'
  },

  title: {
    fontWeight: '700',
    fontSize: '40px',
    textAlign: 'center',
    lineHeight: '45px'
  },

  offerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center'
  },

  offerEndsTitle: {
    fontWeight: '700',
    fontSize: '16px'
  },

  countdown: {
    display: 'flex',
    gap: '10px'
  },

  counterBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: '0.56px solid #2C88FF',
    borderRadius: '8px',
    background: '#FFFFFF',
    color: '#2C88FF',
    padding: '12px 16px 12px 16px',
    fontWeight: '600',
    fontSize: '14px'
  },

  // SMALL SCREEN
  '@media screen and (max-width: 767px)': {
    timerAndCallSection: {
      padding: '24px'
    },
    timerAndCallContainer: {
      padding: '16px'
    },
    timerAndCallBox: {
      gap: '32px'
    },
    title: {
      fontSize: '24px'
    },
    offerWrapper: {
      gap: '16px'
    }
  }
}));

export default useTimerCallPageStyles;
